import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly10D2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10D/6.webp`;



  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
   
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                  AYURVEDA – A NATURE’S WAY OF WELLNESS
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 10D   Date: 19 JUNE 2026
                </Typography>

<Typography variant={'subtitle1'} align={'justify'}>
  The students of Class 10D at National Public School, Yeshwanthpur, presented
  an enlightening assembly on the theme
   “Sharirik Chikitsa – The Ayurvedic Path to Physical Well-being.”
  <br></br>
  Day 1 commenced with a profound exposition on Sharirik Chikitsa,
  underscoring its pivotal role in cultivating holistic health through natural
  therapies, yogic discipline and the art of balanced living.
  <br></br>
  Day 2 unfolded with a reflective thought for the day, followed by an engaging
  skit depicting the impact of stress and unhealthy habits on the human body.
  Through the personification of various organs, students effectively
  demonstrated the importance of maintaining physical and mental well-being.
  The assembly also featured a vibrant ramp walk showcasing medicinal herbs and
  yoga postures that support the health of different organs.
  <br></br>
  The presentation emphasized the values of self-care, balance and healthy
  living, concluding with the message:
    “When we care for our bodies and live in harmony with nature, we build the
    foundation for a healthier and happier life.”
  <br></br>
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                &ldquo;”A healthy body is the foundation of a healthy mind.”&rdquo;
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10D 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly10D2026;
